

export function celcius_to_fahrenheit(deg_c) {
    return 32 + Math.round(deg_c * 1.8);
}
